import { DesignSections } from 'records/DesignSection';
import BaseList from 'records/BaseList';

import {
  DESIGN_SECTIONS_ASYNC_ACTION_START,
  DESIGN_SECTIONS_ASYNC_ACTION_ERROR,
  DESIGN_SECTIONS_ASYNC_ACTION_SUCCESS,
  DESIGN_SECTIONS_UPDATE_ACTION_SUCCESS,
  DESIGN_SECTIONS_RESET_STATE,
} from 'actions/designSections';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: DesignSections(),
});

const actionsMap = {
  [DESIGN_SECTIONS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [DESIGN_SECTIONS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [DESIGN_SECTIONS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignSections(action.data),
    });
  },
  [DESIGN_SECTIONS_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new BaseList({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [DESIGN_SECTIONS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function designSections(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
